import { render, staticRenderFns } from "./patientDetail.vue?vue&type=template&id=54045a22&scoped=true&"
import script from "./patientDetail.vue?vue&type=script&lang=js&"
export * from "./patientDetail.vue?vue&type=script&lang=js&"
import style0 from "./patientDetail.vue?vue&type=style&index=0&id=54045a22&lang=scss&scoped=true&"
import style1 from "./patientDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54045a22",
  null
  
)

export default component.exports